import React from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { MapPin, Download, MessageSquare, Phone,Brain } from 'lucide-react';

export default function HomePage() {
  const navigate = useNavigate();
  const quickLinks = [
    { title: 'Find a Hub', to: '/hubs', icon: <MapPin className="w-8 h-8 text-green-500" /> },
    { title: 'Download Guides', to: '/resources', icon: <Download className="w-8 h-8 text-green-500" /> },
    { title: 'Join the Forum', to: '/forum', icon: <MessageSquare className="w-8 h-8 text-green-500" /> },
    { title: 'Chat with Vita AI', to: '/gemini', icon: <Brain className="w-8 h-8 text-green-500" /> },
  ];

  return (
    <div>
      <section className="bg-green-50 text-center py-20 lg:py-32">
        <div className="container mx-auto px-4">
          <h1 className="text-4xl md:text-5xl font-extrabold text-gray-800">Empowering Rural World, One Household at a Time</h1>
          <p className="mt-4 text-lg md:text-xl text-gray-600 max-w-3xl mx-auto">VitaBridge provides access to vital resources, knowledge, and community support to enhance food security and create sustainable livelihoods.</p>
          <button onClick={() => navigate('/hubs')} className="mt-8 bg-green-600 text-white font-bold py-3 px-8 rounded-full hover:bg-green-700 transition-transform transform hover:scale-105">
            Get Started
          </button>
        </div>
      </section>
      <section className="py-16 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-3xl font-bold text-center text-gray-800 mb-12">Your Gateway to Growth</h2>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {quickLinks.map(link => (
              <Link key={link.title} to={link.to} className="p-6 bg-gray-50 rounded-lg shadow-md hover:shadow-xl transition-shadow cursor-pointer text-center block">
                <div className="flex justify-center mb-4">{link.icon}</div>
                <h3 className="text-xl font-semibold text-gray-700">{link.title}</h3>
              </Link>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
}


